import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import messageHandler from 'utils/messageHandler';

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    loading: true,
    notifications: []
  },
  reducers: {
    setNotifications: (state, { payload }) => {
      state.notifications = payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    }
  }
});

export const { setNotifications, setLoading } = notificationsSlice.actions;

export const getNotifications = userId => async dispatch => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}/notifications/find-by-user/${userId}`
    );
    dispatch(setNotifications(data));
    dispatch(setLoading(false));
  } catch (error) {
    messageHandler('error', error.response?.data?.message);
  }
};

export const markAsRead = notiId => async () => {
  try {
    const response = await axios({
      method: 'PATCH',
      url: `${process.env.REACT_APP_SERVER}/notifications/read/${notiId}`
    });
    return response;
  } catch (error) {
    messageHandler('error', error.response?.data?.message);
  }
};

export const markAllAsRead = userId => async () => {
  try {
    const response = await axios({
      method: 'PATCH',
      url: `${process.env.REACT_APP_SERVER}/notifications/read-by-user/${userId}`
    });
    return response;
  } catch (error) {
    messageHandler('error', error.response?.data?.message);
  }
};

export const markAllAsSeen = userId => async () => {
  try {
    const response = await axios({
      method: 'PATCH',
      url: `${process.env.REACT_APP_SERVER}/notifications/seen-by-user/${userId}`
    });
    return response;
  } catch (error) {
    messageHandler('error', error.response?.data?.message);
  }
};

export default notificationsSlice.reducer;
